import {
  Dialog,
  DialogContent,
  BUTTON_VARIANTS,
  Checkbox,
  Button,
} from 'cdk-radial';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { environmentURLs } from '../common/CaptureEnvironment';

import './TermsViewer.scss';

const formatDate = (date) => {
  const unformattedDate = new Date(date);
  const year = unformattedDate.getFullYear();
  const month = (1 + unformattedDate.getMonth()).toString().padStart(2, '0');
  const day = unformattedDate.getDate().toString().padStart(2, '0');
  return month + '/' + day + '/' + year;
};

export const TermsViewer = (props) => {
  const { isTermsOpen, setIsTermsOpen } = props;
  const { authenticationToken: token } = useSelector(
    (state) => state.loginDetailsSlice
  );

  const [checked, setChecked] = useState(false);

  const [termsBlob, setTermsBlob] = useState();

  const [consentedTermsUrl, setConsentedTermsUrl] = useState();

  const [continueButtonIsDisabled, setContinueButtonIsDisabled] =
    useState(true);

  const [termsResponse, setTermsResponse] = useState(false);

  const handleContinue = () => {
    setIsTermsOpen(false);
    acceptTerms();
  };

  const handleDecline = () => {
    setIsTermsOpen(false);
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
    setContinueButtonIsDisabled(!event.target.checked);
  };

  const acceptTerms = async () => {
    try {
      await axios.post(
        `${environmentURLs.REACT_APP_DEALER_API_BUYER_SERVICE_URL}/consent`,
        {
          file: termsBlob,
          msaDocId: termsResponse.msaDocId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error('Error submitting terms', error);
    }
  };

  const loadTerms = async () => {
    try {
      const response = await axios.get(
        `${environmentURLs.REACT_APP_DEALER_API_BUYER_SERVICE_URL}/consent?resolveConsentDocument=true`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data } = response;
      setTermsResponse(data);
    } catch (error) {
      console.error('Fetching terms not successful', error);
    }
  };

  useEffect(() => {
    loadTerms();
  }, []);

  useEffect(() => {
    if (termsResponse.consentStatus === 'not_consented') {
      setTermsBlob(termsResponse.msaDocFile);
    } else if (termsResponse.consentStatus === 'consented') {
      setConsentedTermsUrl(termsResponse.consentedDocUrl);
    }
  }, [termsResponse]);

  const renderCustomFooter = () => (
    <div
      style={{
        padding: '16px',
      }}
    >
      <Checkbox
        dataTestId="terms-accept-checkbox"
        id="terms-accept-checkbox"
        label="I comply with the statement above"
        labelPosition="after"
        name="terms-accept-checkbox"
        onChange={handleCheckboxChange}
        size="standard"
        checked={checked}
      />

      <div class="terms-btn-container">
        <Button
          id="api-terms-dialog-decline"
          onClick={handleDecline}
          text="Decline"
          variant={BUTTON_VARIANTS.SECONDARY}
          className="api-terms-button"
        />

        <div class="terms-btn-divider"></div>

        <Button
          id="api-terms-dialog-decline"
          onClick={handleContinue}
          text="Continue"
          variant={BUTTON_VARIANTS.PRIMARY}
          isDisabled={continueButtonIsDisabled}
          className="api-terms-button"
        />
      </div>
    </div>
  );

  if (termsResponse.consentStatus === 'consented') {
    return (
      <Dialog
        id="api-terms-dialog"
        title={`API Purchase Compliance Addendum`}
        isOpen={termsResponse && isTermsOpen}
        onClose={() => {
          setIsTermsOpen(false);
        }}
      >
        <DialogContent>
          <div className="accepted-terms-dialog-meta-data">
            <div>{`Accepted on: ${formatDate(
              termsResponse?.consentedDate
            )}`}</div>
            <div>{`Accepted by: ${termsResponse?.consentedUserName}`}</div>
          </div>

          <iframe
            className="app-review-terms-doc"
            title={'Terms and Conditions'}
            src={`${consentedTermsUrl}`}
          />
        </DialogContent>
      </Dialog>
    );
  } else if (termsResponse.consentStatus === 'not_consented') {
    return (
      <Dialog
        id="api-terms-dialog"
        title={`API Purchase Compliance Addendum`}
        isOpen={termsResponse && isTermsOpen}
        hideCloseButton={true}
        renderCustomFooterComponent={renderCustomFooter}
      >
        <DialogContent>
          <iframe
            className="app-review-terms-doc"
            title={'Terms and Conditions'}
            src={`data:application/pdf;base64,${termsBlob}`}
          />
        </DialogContent>
      </Dialog>
    );
  } else {
    return null;
  }
};
